<template>
  <page-header-wrapper>
    <a-card :bordered="false">
      <!-- 条件搜索 -->
      <div class="table-page-search-wrapper">
        <a-form layout="inline">
          <a-row :gutter="48">
            <a-col :md="6" :sm="24">
              <a-form-item label="Contact" prop="mobile">
                <a-input v-model="queryParam.mobile" @pressEnter="handleQuery" placeholder="Please enter contact" allow-clear />
              </a-form-item>
            </a-col>
            <!--            <a-col :md="6" :sm="24">-->
            <!--              <a-form-item :label="$t('用户ID')" prop="userId">-->
            <!--                <a-input v-model="queryParam.userId" @pressEnter="handleQuery" :placeholder="$t('请输入')+$t('用户ID')" allow-clear />-->
            <!--              </a-form-item>-->
            <!--            </a-col>-->
            <a-col :md="6" :sm="24">
              <a-form-item label="Audit Status" prop="status">
                <a-select placeholder="Please select audit status" v-model="queryParam.status" style="width: 100%" allow-clear>
                  <a-select-option v-for="(d, index) in dict.type.user_cancel_status" :key="index" :value="d.value">{{ translateDict(d.label) }}</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item label="Cancel Reason" prop="reason">
                <a-input v-model="queryParam.reason" @pressEnter="handleQuery" placeholder="Please enter cancel reason" allow-clear />
              </a-form-item>
            </a-col>
            <a-col :md="!advanced && 6 || 24" :sm="24">
              <span class="table-page-search-submitButtons" :style="advanced && { float: 'right', overflow: 'hidden' } || {} ">
                <a-button type="primary" @click="handleQuery"><a-icon type="search" />Query</a-button>
                <a-button style="margin-left: 8px" @click="resetQuery"><a-icon type="redo" />Reset</a-button>
              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>
      <!-- 操作 -->
      <div class="table-operations">
        <a-button type="primary" :disabled="multiple" @click="handleAuditPass" v-hasPermi="['biz:cancel:edit']">
            Approve
        </a-button>
        <a-button type="danger" :disabled="multiple" @click="handleAuditReject" v-hasPermi="['biz:cancel:edit']">
           Reject
        </a-button>
        <!--        <a-button type="primary" @click="handleExport" v-hasPermi="['biz:cancel:export']">-->
        <!--          <a-icon type="download" />-->
        <!--          {{ $t('导出') }}-->
        <!--        </a-button>-->
        <!--        <a-button type="primary" :disabled="multiple" @click="handleSelectExport" v-hasPermi="['biz:cancel:export']">-->
        <!--          <a-icon type="download" />-->
        <!--          {{ $t('选中导出') }}-->
        <!--        </a-button>-->
        <table-setting
          :style="{float: 'right'}"
          :table-size.sync="tableSize"
          v-model="columns"
          :refresh-loading="loading"
          @refresh="getList" />
      </div>
      <!-- 增加修改 -->
      <create-form
        ref="createForm"
        :statusOptions="dict.type.user_cancel_status"
        @ok="getList"
      />
      <!-- 数据展示 -->
      <a-table
        :loading="loading"
        :size="tableSize"
        rowKey="id"
        :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
        :columns="columns"
        :data-source="list"
        :pagination="false"
        :bordered="tableBordered"
        :scroll="{ x: '160%', y: tableScrollY }"
      >
        <span slot="status" slot-scope="text, record">
          <dict-tag :options="dict.type['user_cancel_status']" :value="record.status" />
        </span>
        <span slot="examineTime" slot-scope="text, record">
          {{ parseTime(record.examineTime) }}
        </span>
        <span slot="createTime" slot-scope="text, record">
          {{ parseTime(record.createTime) }}
        </span>
        <span slot="operation" slot-scope="text, record">
          <a @click="$refs.createForm.handleUpdate(record, undefined)" v-if="record.status===1" v-hasPermi="['biz:cancel:edit']">
            <a-icon type="edit" />Audit
          </a>
        </span>
      </a-table>
      <!-- 驳回原因 -->
      <a-modal
        :title="$t('驳回原因')"
        :visible="rejectVisible"
        @ok="submitReject"
        @cancel="rejectVisible = false"
        :confirm-loading="rejectLoading"
      >
        <a-textarea v-model="rejectReason" :rows="4" :placeholder="$t('请输入驳回原因')" />
      </a-modal>
      <!-- 分页 -->
      <a-pagination
        class="ant-table-pagination"
        :pageSizeOptions="pageSizeOptions"
        show-size-changer
        show-quick-jumper
        :current="queryParam.pageNum"
        :total="total"
        :page-size="queryParam.pageSize"
        :show-total="total => `Total ${total} items`"
        @showSizeChange="onShowSizeChange"
        @change="changeSize"
      />
    </a-card>
  </page-header-wrapper>
</template>

<script>
import { pageCancel, listCancel, delCancel, updateCancel } from '@/api/biz/cancel'
import CreateForm from './modules/CreateForm'
import { tableMixin } from '@/store/table-mixin'

export default {
  name: 'Cancel',
  components: {
    CreateForm
  },
  mixins: [tableMixin],
  dicts: ['user_cancel_status'],
  data() {
    return {
      pageSizeOptions: ['10', '20', '50', '100'],
      list: [],
      selectedRowKeys: [],
      selectedRows: [],
      // 高级搜索 展开/关闭
      advanced: false,
      // 非单个禁用
      single: true,
      // 非多个禁用
      multiple: true,
      ids: [],
      loading: false,
      rejectVisible: false,
      rejectLoading: false,
      rejectReason: '',
      total: 0,
      // 查询参数
      queryParam: {
        mobile: null,
        reason: null,
        failReason: null,
        examineName: null,
        examineTime: null,
        pageNum: 1,
        pageSize: 10
      },
      columns: [
        // {
        //   title: 'User ID',
        //   dataIndex: 'userId',
        //   align: 'center'
        // },
        {
          title: this.$t('昵称'),
          dataIndex: 'nickName',
          ellipsis: true,
          align: 'center',
          fixed: 'left'
        },
        {
          title: this.$t('联系方式'),
          dataIndex: 'mobile',
          ellipsis: true,
          align: 'center'
        },
        {
          title: this.$t('注销原因'),
          dataIndex: 'reason',
          ellipsis: true,
          align: 'center'
        },
        {
          title: this.$t('审核状态'),
          dataIndex: 'status',
          scopedSlots: { customRender: 'status' },
          ellipsis: true,
          align: 'center'
        },
        {
          title: this.$t('审核失败原因'),
          dataIndex: 'failReason',
          ellipsis: true,
          align: 'center'
        },
        {
          title: this.$t('审核人'),
          dataIndex: 'examineName',
          ellipsis: true,
          align: 'center'
        },
        {
          title: this.$t('审核时间'),
          dataIndex: 'examineTime',
          scopedSlots: { customRender: 'examineTime' },
          ellipsis: true,
          align: 'center'
        },
        {
          title: this.$t('注销时间'),
          dataIndex: 'createTime',
          scopedSlots: { customRender: 'createTime' },
          ellipsis: true,
          align: 'center'
        },
        {
          title: this.$t('操作'),
          dataIndex: 'operation',
          width: '120px',
          scopedSlots: { customRender: 'operation' },
          align: 'center',
          fixed: 'right'
        }
      ]
    }
  },
  filters: {},
  created() {
    this.getList()
  },
  computed: {},
  watch: {},
  methods: {
    // 将中文字典标签翻译为英文显示
    translateDict(label) {
      if (!label) return ''
      const map = {
        '待审核': 'Pending Review',
        '审核成功': 'Approved',
        '审核通过': 'Approved',
        '审核失败': 'Rejected',
        '审核拒绝': 'Rejected',
        '0': 'Pending Review',
        '1': 'Approved',
        '2': 'Rejected'
      }
      return map[label] || label
    },
    /** 查询用户注销列表 */
    getList() {
      this.loading = true
      pageCancel(this.queryParam).then(response => {
        this.list = response.data.records
        this.total = response.data.total
        this.loading = false
      })
    },

    /** 搜索按钮操作 */
    handleQuery() {
      this.queryParam.pageNum = 1
      this.getList()
    },
    /** 重置按钮操作 */
    resetQuery() {
      this.queryParam = {
        userId: undefined,
        mobile: undefined,
        reason: undefined,
        status: undefined,
        failReason: undefined,
        examineName: undefined,
        examineTime: undefined,
        pageNum: 1,
        pageSize: 10
      }
      this.handleQuery()
    },
    onShowSizeChange(current, pageSize) {
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    changeSize(current, pageSize) {
      this.queryParam.pageNum = current
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    onSelectChange(selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
      this.ids = this.selectedRows.map(item => item.id)
      this.single = selectedRowKeys.length !== 1
      this.multiple = !selectedRowKeys.length
    },
    toggleAdvanced() {
      this.advanced = !this.advanced
    },
    /** 删除按钮操作 */
    handleDelete(row) {
      var that = this
      const ids = row.id || this.ids
      if (row.id) {
        this.ids.push(row.id)
      }
      this.$confirm({
        title: 'Confirm to delete the selected data?',
        content: 'Currently selected ID: ' + ids,
        onOk() {
          let data = []
          that.ids.map(id => data.push({ 'id': id }))
          return delCancel(data)
            .then(() => {
              that.onSelectChange([], [])
              that.getList()
              that.$message.success(
                'Deleted successfully',
                3
              )
            })
        },
        onCancel() {
          //取消清空删除ids列表
          that.ids = []
        }
      })
    },
    /** 导出按钮操作 */
    handleExport() {
      var that = this
      this.$confirm({
        title: 'Confirm to export?',
        content: 'This operation will export all data under the current conditions, not the selected data',
        onOk() {
          that.download('biz/user-cancel/export',
            that.queryParam
            , `user_cancel_${new Date().getTime()}.xlsx`)
        },
        onCancel() {
        }
      })
    },
    handleSelectExport() {
      var that = this
      let queryParam = { 'idList': this.ids }
      this.$confirm({
        title: 'Confirm to export',
        content: 'This operation will export the selected data',
        onOk() {
          that.download('biz/user-cancel/export', queryParam, `user_cancel_${new Date().getTime()}.xlsx`)
          that.ids = []
          that.multiple = true
          that.selectedRowKeys = []
        },
        onCancel() {
          that.ids = []
          that.multiple = true
          that.selectedRowKeys = []
        }
      })
    },
    handleAuditPass() {
      const that = this
      if (this.ids.length === 0) {
        return
      }
      this.$confirm({
        title: this.$t('确认审核通过该批注销申请？'),
        onOk() {
          const tasks = that.ids.map(id => updateCancel({ id: id, status: 2 }))
          return Promise.all(tasks).then(() => {
            that.onSelectChange([], [])
            that.getList()
            that.$message.success(that.$t('审核成功'), 3)
          })
        }
      })
    },
    handleAuditReject() {
      if (this.ids.length === 0) {
        return
      }
      this.rejectReason = ''
      this.rejectVisible = true
    },
    submitReject() {
      const that = this
      if (!this.rejectReason) {
        this.$message.warning(this.$t('请输入驳回原因'))
        return
      }
      this.rejectLoading = true
      const tasks = this.ids.map(id => updateCancel({ id: id, status: 3, failReason: this.rejectReason }))
      Promise.all(tasks).then(() => {
        that.$message.success(that.$t('已驳回'), 3)
        that.rejectVisible = false
        that.onSelectChange([], [])
        that.getList()
      }).finally(() => {
        that.rejectLoading = false
      })
    }
  }
}
</script>
